<style lang="scss" scoped>
.el-button {
  width: 60px;
  margin-left: 10px;
}
.table {
  background: #fff;
  height: 500px;
}
.blue {
  color: #173bcf;
}
/deep/ .el-table th {
  background: #fff;
}
</style>

<template>
  <div>
    <div>
      <el-date-picker
        v-model="value"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        format="dd/MM/yyyy"
        :picker-options="option"
        @change="changeDate"
      ></el-date-picker>
      <el-button size="mini" type="primary">查询</el-button>
    </div>
    <div class="clearfix mb20">
      <down-load :tdata="downloadStr" filename=".channels">
        <span href class="fr blue">
          <i class="iconfont iconxiazai1"></i>下载表格
        </span>
      </down-load>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="name" label="渠道二维码名称"></el-table-column>
        <el-table-column prop="scanCount" label="扫码总数"></el-table-column>
        <el-table-column prop="subscribe" label="新粉丝"></el-table-column>
        <el-table-column prop="subscribed" label="老粉丝"></el-table-column>
        <el-table-column prop="unsubscribe" label="取消关注"></el-table-column>
        <el-table-column label="统计">
          <template slot-scope="scope">
            <router-link class="blue" :to="{path:'refer/details',query: {id:scope.row.qrCodeId}}">详情</router-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="mt30 alignc">
      <el-pagination
        layout="prev, pager, next"
        :page-size="pageSize"
        :current-page="page"
        :total="total"
        @current-change="changePage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import DownLoad from '@/components/download';
export default {
  components: {
    DownLoad,
  },
  computed: {},
  props: ['id'],
  data() {
    const start = new Date();
    return {
      loading: true,
      value: [start.getTime() - 3600 * 1000 * 24 * 30, start],
      page: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      option: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      downloadStr: '',
    };
  },
  async mounted() {
    await this.getData();
    this.getAllData();
  },
  methods: {
    async getAllData() {
      let res = await this.$http.get(
        `/api/${this.id}/download/channel/qrcodes`,
        {
          params: {
            page: 1,
            size: 10000000,
            begin: this.moment(this.value[0]) || null,
            end: this.moment(this.value[1]) || null,
          },
          responseType: 'blob',
        },
      );

      if (res) {
        this.downloadStr = res;
      }
    },

    async changePage(val) {
      this.page = val;
      await this.getData();
    },
    async changeDate() {
      await this.getData();
      this.getAllData();
    },
    async getData() {
      this.loading = true;
      let res = await this.$http.get(
        `/api/${this.id}/analyze/channel/qrcodes`,
        {
          params: {
            page: this.page,
            size: this.pageSize,
            begin: this.moment(this.value[0]) || null,
            end: this.moment(this.value[1]) || null,
          },
        },
      );

      this.tableData = res.list;
      this.total = res.totalSize;
      setTimeout(() => {
        this.loading = false;
      }, 300);
    },
  },
};
</script>
